import { Dropdown, Input, Table } from "antd";
import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Link, useNavigate } from "react-router-dom";
import toast from "react-hot-toast";
import svg27 from "../../../assets/svg/svg27.svg"; 
import InsideHeader from "../../../components/InsideHeader"; 
import svg38 from "../../../assets/svg/svg38.svg";
import MaterialIcon from "material-icons-react"; 
import { fetchFiscPeriodsII } from "../../../features/dropdown/dropdownSlice";
import { numberWithCommas } from "../../../utils";
import { setStaffObj } from "../../../features/folder/folderSlice";
import FilterModal from "./FilterModal";
import svg67 from "../../../assets/svg/svg67.svg";
 

export default function PayrollPaymentTable() {
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const { fiscPeriodsII, loading, fiscPeriodsIICount } = useSelector(
    (state) => state.dropdown
  );
  const { staffloading } = useSelector((state) => state.staff);

  const [searchText, setSearchText] = useState("");

  const [open, setopen] = useState(false);

  function handleCancel() {
    setopen(false);
  }
  const [filters, setFilters] = useState([]);
  const [formData, setFormData] = useState({});
  const [isModalOpen, setIsModalOpen] = useState(false);
  const showModalFilter = () => {
    setIsModalOpen(true);
  };

  const handleClearFilters = async () => {
    await setFormData({});
    await dispatch(fetchFiscPeriodsII());
    await setFilters([]);
  };

  const [prodd, setProdd] = useState("");
  const [isModalOpenDelete, setIsModalOpenDelete] = useState(false);
  const showModalDelete = async () => {
    setIsModalOpenDelete(true);
  };

  const handleDelete = async () => {
    
  };

  const handleNdovu = async () => {
    navigate('/ndovu-pay')
  };

  const handleExport = () => {
     
  };

  const handleView=async()=>{
    await dispatch(setStaffObj(prodd))
    await navigate("/staff-net")
  }
  const settingItems = [
    {
      key: "0",
      label: (
        <Link
          onClick={handleView}
          className="flex  text-[16px] font-sans  !text-lightBlack"
        >
         Details
        </Link>
      ),
    },
    // {
    //   key: "1",
    //   label: (
    //     <Link
    //       onClick={handleExport}
    //       className="flex  text-[16px] font-sans  !text-lightBlack"
    //     >
    //       Export To Excel
    //     </Link>
    //   ),
    // },
    // {
    //   key: "2",
    //   label: (
    //     <div
    //       onClick={handleNdovu}
    //       className="flex  text-[16px] font-sans   !text-lightBlack"
    //     >
    //       Initiate Ndovupay Payment
    //     </div>
    //   ),
    // },
  ];

  const columns = [
    {
      title: "Calendar Year",
      dataIndex: "fpPyear",
      sorter: (a, b) => a.fpPyear - b.fpPyear,
    },
    {
      title: "Month",
      dataIndex: "fpPmonth",
      sorter: (a, b) => a.fpPmonth - b.fpPmonth,
    },

    {
      title: "Active",
      dataIndex: "fpActive", 
    },  
    {
      title: "Status",
      dataIndex: "fpPaymentStatus",
      render: (item) => {
        return (
          <div
            className={`${
              item === "PENDING_PAYMENT" || item == null ? "bg-[#FFB74D]" : item === "FAILED" ? "bg-[#FF4D4F]":item === "IN_COMPLETE" ? "bg-[#FFCC80]" : item === "PROCESSING" ? "bg-[#FFC107]": item === "COMPLETED" ?"bg-darkGreen" : null
            }  text-[#FFf] font-[700] inline-block rounded-[5px] px-2 py-1 w-auto`}
          >
            {item?? "PENDING PAYMENT"}
          </div>
        );
      },
    },
    {
      title: "Total Net Amount",
      dataIndex: "totalNetAmount",
      sorter: (a, b) => a.totalNetAmount - b.totalNetAmount,
      render:(item)=>{
        return(
          <div>{numberWithCommas(item)}</div>
        )
      }
    },


    {
      title: "Actions",
      render: (item) => (
        <>
          <Dropdown
            overlayStyle={{
              width: "250px",
            }}
            trigger={"click"}
            menu={{ items: settingItems }}
            placement="bottom"
          >
            <button onClick={() => setProdd(item)}>
              <img src={svg27} alt="svg27" />
            </button>
          </Dropdown>
        </>
      ),
    },
  ];

  const [pageIndex, setPageIndex] = useState(0);
  const [pageSize, setPageSize] = useState(10);

  async function fetchFiscPeriodsIIData(page, size) {
    dispatch(
      fetchFiscPeriodsII({
        limit: size ?? pageSize,
        start: page ?? pageIndex,
      })
    );
  }

  useEffect(() => {
    fetchFiscPeriodsIIData();
  }, []);

  return (
    <div className="w-full h-full overflow-y-scroll">
      <InsideHeader
        title="Fiscal Periods Information"
        subtitle="Manage Fiscal Periods within your institution"
        back={false}
      />
 
        <div className="bg-white rounded-[10px] mt-[1.25rem] h-full">
          <div className="flex flex-col w-full lg:px-10 px-3 ">
            <h3 className="font-[700] text-[24px] text-lightBlack dash-title mt-[1.25rem]">
              Fiscal Periods Details
            </h3>
            <div className="mt-5 flex lg:flex-row flex-col gap-y-5 justify-between lg:items-center items-start w-full">
              <div className="flex items-center">
                <span>
                  {" "}
                  <button
                    onClick={showModalFilter}
                    type="button"
                    className={`bg-transparent flex items-center gap-x-'1' ${
                      Object?.keys(formData)?.length > 0
                        ? "!text-[#5688E5]"
                        : "inherit"
                    }`}
                  >
                    <MaterialIcon color="#141414" icon="filter_list" />
                    Filters
                  </button>
                </span>
                

                {Object?.keys(formData)?.length > 0 && (
                  <span className="flex items-center text-[#5688E5] cursor-pointer ml-1">
                    :{Object?.keys(formData)?.length}
                    <img src={svg38} alt="svg38" onClick={handleClearFilters} />
                  </span>
                )}
              </div>

              <div className="cursor-pointer flex w-full items-center justify-center" onClick={()=>fetchFiscPeriodsIIData(0,10)}>  
            <img src={svg67} alt="svg67"/>
         </div>
           
            </div>
            <div className="dash-inner-page mt-[24px] max-w-full w-full overflow-x-auto">
              <section>
                <Table
                  rowSelection={false}
                  className="mt-[1.31rem] w-full"
                  scroll={{
                    x: 800,
                  }}
                  rowKey={(record) => record?.fpId}
                  columns={columns}
                  dataSource={fiscPeriodsII}
                  loading={loading}
                  pagination={{
                    position: ["bottomCenter"],
                    current: pageIndex + 1,
                    total: fiscPeriodsIICount,
                    pageSize: pageSize,
                    onChange: (page, size) => {
                      setPageIndex(page - 1);
                      setPageSize(size);
                      fetchFiscPeriodsIIData(page - 1, size);
                    },
                    showSizeChanger: false,
                    hideOnSinglePage: true,
                  }}
                />
              </section>
            </div>
          </div>
        </div>
   
 
      <FilterModal
        isModalOpen={isModalOpen}
        setIsModalOpen={setIsModalOpen}
        formData={formData}
        setFormData={setFormData}
        filters={filters}
        setFilters={setFilters}
      />
    </div>
  );
}
